<template>
  <div class="charts-block">
    <div v-for="(item, index) in chartsData" :key="index" class="charts-item">
      <!--头部选项-->
      <div class="charts-header">
        <div v-if="item.name !== ''" class="charts-choice">
          <button class="jj-button bg-white cursor" disabled>
            {{ item.name }}
          </button>
        </div>
        <div class="charts-choice" v-if="item.title !== ''">
          <button
            class="jj-button bg-white"
            v-for="(item1, index1) in item.title"
            :key="item1"
            :class="item.activeIndex === index1 ? 'jj-button-active' : ''"
            @click="changeActiveIndex(index, index1)"
          >
            {{ item1 }}
          </button>
        </div>

        <div v-if="item.timepicker">
          <el-date-picker
            v-model="item.timeArr"
            type="daterange"
            range-separator="|"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="checkTime(item)"
          >
          </el-date-picker>
        </div>
      </div>
      <div
        class="charts"
        :id="item.id"
        v-if="item.type !== 'table'"
        :style="{
          width: '100%',
          height: '400px',
          background: '#fff',
          overflow: 'hidden'
        }"
      ></div>
      <div class="charts tableWrap table" v-else>
        <el-table
          :data="item.dataArr[item.activeIndex]"
          style="width: 99.9%"
          :header-cell-style="{ background: '#eeeeee', color: '#000000' }"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column prop="title" label="日記標題">
            <template slot-scope="scope">
              {{
                scope.row.title && scope.row.title.length >= 8
                  ? scope.row.title.substring(0, 9) + "..."
                  : scope.row.title
              }}
            </template>
          </el-table-column>
          <el-table-column prop="publishDate" label="發布時間">
          </el-table-column>
          <el-table-column prop="count" label="數據"> </el-table-column>
        </el-table>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import echarts from "echarts";
import DiaMess from "@/components/dialog";

export default {
  name: "JjCharts",
  props: {
    chartsData: {
      type: Array,
      default: null
    }
  },
  components: {
    DiaMess
  },
  data() {
    return {
      charts: [],
      color: ["#775CFF", "#FF6969", "#A3CE52", "#E1AC67", "#46CB82", "#45D2D7"],
      dialogVisible: false
    };
  },
  created() {
    let _this = this;
    this.$nextTick(() => {
      _this.drawLine();
    });
  },
  mounted() {},
  methods: {
    drawLine() {
      let _this = this;
      for (let i = 0; i < this.chartsData.length; i++) {
        if (this.chartsData[i].type === "line") {
          _this.charts[i] = echarts.init(
            document.getElementById(_this.chartsData[i].id)
          );
          let data = this.chartsData[i];
          let option = this.getLineOption();
          option.series.push(_this.getSeries());
          option.series[0].data = data.dataArr[data.activeIndex];
          option.xAxis.data = data.dateArr;
          this.charts[i].setOption(option);
        } else if (this.chartsData[i].type === "area") {
          _this.charts[i] = echarts.init(
            document.getElementById(_this.chartsData[i].id)
          );
          let data = this.chartsData[i];
          let option = this.getLineOption();
          option["legend"] = { data: [], bottom: 0, icon: "roundRect" };
          data.dataArr.forEach(v => {
            let index = data.dataArr.indexOf(v);
            let series = _this.getSeries();
            series["areaStyle"] = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: _this.color[index]
                },
                {
                  offset: 1,
                  color: "rgb(255, 255, 255)"
                }
              ])
            };
            series.itemStyle.normal.color = _this.color[index];
            series.itemStyle.normal.lineStyle.color = _this.color[index];
            series["data"] = v.data;
            series["name"] = v.title;
            option.series.push(series);
            option.legend.data.push(v.title);
          });
          option.xAxis.data = data.dateArr;
          this.charts[i].setOption(option);
        }
      }
    },
    // 折线图
    getLineOption() {
      let option = {
        lineHeight: 100,
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          axisLabel: {
            color: "#8D8D8D"
          },
          axisLine: {
            lineStyle: {
              color: "#BFBFBF"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: "#8D8D8D"
          },
          splitLine: {
            lineStyle: {
              type: "dotted",
              color: "#E6E6E6"
            }
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        series: []
      };
      return option;
    },
    getAreaSeries() {
      return {
        areaStyle: {}
      };
    },
    changeActiveIndex(index, index1) {
      this.chartsData[index].activeIndex = index1;
    },

    // 判断时间并给出对应的反应
    checkTime(item) {
      let _this = this;
      let time = new Date();
      let value = item.timeArr;
      if (time.getTime() < value[0].getTime()) {
        _this.dialogVisible = true;
        _this.$propMessage("开始时间不能晚于当前时间", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (time.getTime() < value[1].getTime()) {
        _this.dialogVisible = true;
        _this.$propMessage("结束时间不能晚于当前时间", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (value[1].getTime() - value[0].getTime() < 24 * 3600 * 1000) {
        _this.dialogVisible = true;
        _this.$propMessage("时间间隔不能小于两天", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      value[0] = this.formatTime(value[0]) + " 00:00:00";

      value[1] = this.formatTime(value[1]);
      this.$emit("time", value, item.id);
    },

    getSeries() {
      return {
        name: "",
        type: "line",
        smooth: true,
        itemStyle: {
          normal: {
            color: "#6c3dea", // 设置转折点颜色
            lineStyle: {
              color: "#6c3dea" // 设置线条颜色
            }
          }
        }
      };
    },

    formatTime(date) {
      var year = date.getFullYear(); //得到年份
      var month = date.getMonth(); //得到月份
      var date = date.getDate(); //得到日期
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      return year + "-" + month + "-" + date;
    }
  },
  watch: {
    chartsData: {
      handler(newVal, oldVal) {
        let _this = this;
        this.$nextTick(() => {
          _this.drawLine();
        });
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.charts-block {
  display: flex;

  .charts-item {
    flex: 1;
    padding: 0.4rem 0.24rem 0.5rem 0.24rem;
    border-radius: 0.12rem;
    background-color: #ffffff;
    margin-right: 0.28rem;

    .charts-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .charts-choice {
        text-align: left;
      }
    }

    .table {
      margin-top: 0.5rem;
    }
  }

  .charts-item:last-child {
    margin-right: 0;
  }
}

.cursor {
  cursor: default;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 2.5rem;
}

.el-date-editor .el-range-separator {
  padding: 0;
}

.centerY {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/user/components/JjCharts.vue